/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    function ajax_save_session() {
        var dealer_name = $('#input_9_3').val();
        var date = $('#input_9_4').val();
        var address = $('#input_9_5').val();
        var city = $('#input_9_6').val();
        var state = $('#input_9_7').val();
        var zip = $('#input_9_12').val();
        var office_phone = $('#input_9_8').val();
        var cell_phone = $('#input_9_9').val();
        var email = $('#input_9_10').val();
        var signature = $('#input_9_11').val();
        
        var option_quote = null;
        if ($('#choice_9_1_1').is(':checked')) {
            option_quote = $('#choice_9_1_1').val();
        }
        var option_order = null;
        if ($('#choice_9_1_2').is(':checked')) {
            option_order = $('#choice_9_1_2').val();
        }

        $.ajax({
            url: polydesign.ajax_url,
            type: 'post',
            data: {
                action: 'custom_save_session',
                dealer_name: dealer_name,
                date: date,
                address: address,
                city: city,
                state: state,
                zip: zip,
                office_phone: office_phone,
                cell_phone: cell_phone,
                email: email,
                signature: signature,
                option_quote: option_quote,
                option_order: option_order,
            },
            success: function (response) {
                if (response === '1') {
                    console.log('data saved');
                } else {
                    console.log('error');
                }
            }
        });
    }

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'page_template_template_forms': {
            init: function () {
                //initial setting
                $('#forms-list .gform_wrapper').css('display', 'none');
                var current_form = $('#select_product').val();
                $(current_form).show('slow');

                // JavaScript to be fired on the about us page
                $('#select_product').change(function () {
                    $('#forms-list .gform_wrapper').css('display', 'none');
                    $(this.value).show('slow');
                });

                //ajax call to save general form into sessions
                $('#input_9_3').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_5').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_6').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_7').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_12').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_8').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_9').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_10').on('input', function (e) {
                    ajax_save_session();
                });
                $('#input_9_11').on('input', function (e) {
                    ajax_save_session();
                });
                
                $('#input_9_1 li label').click(function (e) {
                    ajax_save_session();
                });
                $('#input_9_1 li input').click(function (e) {
                    ajax_save_session();
                });
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
